import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Row, Col, Container, Button, Collapse } from "react-bootstrap";
import ThemeLogo from "../../assets/Images/BrandLogo/ThemeLogo.png";

export const Footer = () => {
  const [Useopen, UsesetOpen] = useState(false);
  const [Copen, CsetOpen] = useState(false);
  const [Aopen, AsetOpen] = useState(false);
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMenu = () => setClick(false);

  const linkStyle = {
    cursor: "pointer",
  };

  return (
    <>
      <div className="footer">
        <Container>
          <Row className="Footerbox">
            <Col xl={5} lg={5} md={4} sm={12} className="h-100">
              <div className="F-col-1 footer-text d-flex flex-column justify-content-between h-100">
                <img
                  src={ThemeLogo}
                  alt="themeLogo"
                  className="img-fluid WLogo mb-5"
                  style={{ width: "120px", height: "auto" }}
                />
                <div>
                  <span className="fw-bold d-block mb-1" style={{ fontSize: "1.1rem" }}>
                    Italy Cash Puglia
                  </span>
                  <p className="mb-0" style={{ fontSize: "1rem" }}>
                    Il Professional Stores di Tatò Paride S.p.A.
                  </p>
                  <p className="mb-0 mt-2" style={{ fontSize: "1rem" }}>
                    Partita iva: 00855760724
                  </p>
                </div>
              </div>
            </Col>
            <Col xl={2} lg={2} md={2} className="h-100">
              <div className="F-col-2 footer-text FooterVertical d-flex flex-column h-100">
                <h3 className=" footerLinkHeading">
                  Link utili
                  <Button
                    className="Footer-button"
                    onClick={() => UsesetOpen(!Useopen)}
                    aria-controls="example-collapse-text"
                    aria-expanded={Useopen}
                  ></Button>
                </h3>
                <Collapse in={Useopen}>
                  <ul className="list-unstyled">
                    <li>
                      <RouterLink to="/#chisiamo" onClick={closeMenu} style={linkStyle}>
                        Chi siamo
                      </RouterLink>
                    </li>
                    <li>
                      <RouterLink to="/#diventacliente" onClick={closeMenu} style={linkStyle}>
                        Diventa cliente
                      </RouterLink>
                    </li>
                    <li>
                      <RouterLink to="/#cashcarry" onClick={closeMenu} style={linkStyle}>
                        Cash & Carry
                      </RouterLink>
                    </li>
                    <li>
                      <RouterLink to="/#assortimento" onClick={closeMenu} style={linkStyle}>
                        Assortimento
                      </RouterLink>
                    </li>
                    <li>
                      <RouterLink to="/#marchi" onClick={closeMenu} style={linkStyle}>
                        Marchi
                      </RouterLink>
                    </li>
                  </ul>
                </Collapse>
              </div>
            </Col>
            <Col xl={2} lg={2} md={2} className="h-100">
              <div className="F-col-3 footer-text FooterVertical d-flex flex-column h-100">
                <h3 className=" footerLinkHeading">
                  Servizi
                  <Button
                    className="Footer-button"
                    onClick={() => CsetOpen(!Copen)}
                    aria-controls="example-collapse-text"
                    aria-expanded={Copen}
                  ></Button>
                </h3>
                <Collapse in={Copen}>
                  <ul className="list-unstyled">
                    <li>
                      <RouterLink to="/#iscriviti" onClick={closeMenu} style={linkStyle}>
                        Newsletter
                      </RouterLink>
                    </li>
                    <li>
                      <RouterLink to="/signin" onClick={closeMenu} style={linkStyle}>
                        Area Privata
                      </RouterLink>
                    </li>
                    <li>
                      <a
                        href="https://shop.italycashpuglia.it/pdf/CondizioniGeneraliDiVendita.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Condizioni di vendita
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://shop.italycashpuglia.it/pdf/PrivacyPolicy.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a href="mailto:servizio.clienti@italycashpuglia.it">Servizio clienti</a>
                    </li>
                    <li>
                      <a href="mailto:supporto.tecnico@italycashpuglia.it">Supporto tecnico</a>
                    </li>
                  </ul>
                </Collapse>
              </div>
            </Col>
            <Col xl={3} lg={3} md={4} sm={12} className="h-100">
              <div className="F-col-4 footer-text FooterVertical d-flex flex-column h-100">
                <h3 className="footerLinkHeading">
                  Ufficio Direzione
                  <Button
                    className="Footer-button"
                    onClick={() => AsetOpen(!Aopen)}
                    aria-controls="example-collapse-text"
                    aria-expanded={Aopen}
                  ></Button>
                </h3>
                <Collapse in={Aopen}>
                  <div className="quickContact">
                    <div className="contactUsIconContain"></div>
                    <div className="contactUsIconContain">
                      <a href="https://g.co/kgs/fapJQZR" target="_blank" rel="noopener noreferrer">
                        <i className="fa fa-map-marker"></i>
                        <span>
                          Tatò Paride S.p.A.
                          <br></br>Via Foggia, 177
                          <br></br>7612 Barletta (BT)
                        </span>
                      </a>
                    </div>
                    <div className="contactUsIconContain">
                      <a href="mailto:info@tatoparide.it">
                        <i className="fas fa-envelope"></i>
                        <span>info@tatoparide.it</span>
                      </a>
                    </div>
                    <div className="contactUsIconContain">
                      <a href="tel:+390883310811">
                        <i className="fas fa-phone-alt"></i>
                        <span>+39 0883 310811</span>
                      </a>
                    </div>
                  </div>
                </Collapse>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="footer-bottom">
        <h6 className="F-copywrite">Copyright © 2025 • Tutti i diritti riservati</h6>
      </div>
    </>
  );
};
export default Footer;